import {Grid, Typography, MuiIcons} from "@leap4/frontend";
import React from "react";

const { ReportProblem: ReportProblemIcon } = MuiIcons;

const OneOrgOnly = () =>{
    return (
        <>
            <Grid item lg={4} xl={3} margin={2.5}>
                <ReportProblemIcon color={"info"} style={{ fontSize: '500%' }}></ReportProblemIcon>
            </Grid>
            <Grid item>
                <Typography variant="h5" fontFamily={"Quicksand"} fontWeight={600}>
                    {'\nThis page available for one organization picked only!'}
                </Typography>
            </Grid>
        </>
    )
}

export {OneOrgOnly}